import AService from '@/services/AService'

const ENTITY_NAME = 'application';

export default class ApplicationService extends AService {
  async getApplicationLogo() {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/applicationLogo`);
    return response.data;
  }

  async getConfiguration(){
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/configuration`);
    return response.data;
  }
}

